var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #9d1326;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100,
    rx: 15.22,
    ry: 15.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.73,80c-4.19-.17-7.73-1.65-11.12-3.56-4.92-2.78-9.27-6.34-13.4-10.16-5.65-5.23-10.99-10.74-15.51-17-2.53-3.51-4.73-7.21-5.97-11.4-2.11-7.08,.53-12.87,6.21-16.64,.68-.45,1.48-.76,2.26-1.02,1.8-.59,3.28,0,4.24,1.63,1.97,3.35,3.93,6.7,5.89,10.06,.55,.94,1.09,1.89,1.66,2.82,.85,1.37,.82,2.71-.03,4.08-.97,1.57-1.9,3.17-2.84,4.76-.93,1.57-.83,2.84,.28,4.27,4,5.19,8.61,9.79,13.8,13.79,1.39,1.08,2.69,1.18,4.22,.28,1.63-.96,3.26-1.93,4.88-2.91,1.3-.79,2.57-.81,3.89-.03,4.33,2.55,8.67,5.07,13,7.61,1.63,.96,2.19,2.43,1.61,4.25-.98,3.1-3.15,5.24-5.74,7.02-2.26,1.55-4.8,2.2-7.31,2.15Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ec4985ddac974191fa2c186f46d62c53.svg";
export { ForwardRef as ReactComponent };